<template>
  <el-container>
    <el-header>
      <el-page-header title @back="$router.push('/home').catch(() => { })" :content="$t('mensagem')"></el-page-header>
    </el-header>
    <el-main>
      <el-row :gutter="5">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('destinatario') }}</span>
            </div>
            <el-row :gutter="5">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20%">
                <el-col :span="12">
                  <el-form-item :label="$t('cliente')" prop="name">
                    <el-select placeholder="Selecione um cliente">
                      <el-option></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('filtrar')" prop="name">
                    <el-input ref="name" v-model="ruleForm.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="24">
                <div>
                  <el-table :data="tableData1" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="sender" label="Cliente"></el-table-column>
                    <el-table-column prop="sender" label="Usuário"></el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('mensagem') }}</span>
            </div>
            <div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20%">
                <el-form-item :label="$t('assunto')" prop="name">
                  <el-input maxlength="60" show-word-limit ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('mensagem')" prop="name">
                  <el-input type="textarea" rows="8" maxlength="300" show-word-limit v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-form>
              <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{ $t('enviar-mensagem') }}</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "TagsGenerate",
  mixins: [ZipMixins],
  methods: {
    fetchRecords() {
      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}
</style>